/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { ForgotPasswordRequest } from '../models/ForgotPasswordRequest';
import type { ForgotPasswordResponse } from '../models/ForgotPasswordResponse';
import type { GenerateTOTPRequest } from '../models/GenerateTOTPRequest';
import type { LogoutResponse } from '../models/LogoutResponse';
import type { RefreshTokenRequest } from '../models/RefreshTokenRequest';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { ResetPasswordResponse } from '../models/ResetPasswordResponse';
import type { TokenResponse } from '../models/TokenResponse';
import type { TOTPResponse } from '../models/TOTPResponse';
import type { UserLoginRequest } from '../models/UserLoginRequest';
import type { UserRegisterRequest } from '../models/UserRegisterRequest';
import type { UserResponse } from '../models/UserResponse';
import type { VerifyResetCodeRequest } from '../models/VerifyResetCodeRequest';
import type { VerifyResetCodeResponse } from '../models/VerifyResetCodeResponse';
import type { VerifyTOTPRequest } from '../models/VerifyTOTPRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AuthenticationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Register User
     * Register a new user.
     *
     * Args:
     * user_data: User registration data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * AuthResponse: User data and authentication tokens
     *
     * Raises:
     * HTTPException: If registration fails
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public registerUserApiV1AuthRegisterPost(
        requestBody: UserRegisterRequest,
    ): CancelablePromise<AuthResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Register User
     * Register a new user.
     *
     * Args:
     * user_data: User registration data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * AuthResponse: User data and authentication tokens
     *
     * Raises:
     * HTTPException: If registration fails
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public registerUserApiV1AuthRegisterPost1(
        requestBody: UserRegisterRequest,
    ): CancelablePromise<AuthResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login User
     * Login user with email and password.
     *
     * Args:
     * login_data: User login credentials
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * AuthResponse: User data and authentication tokens
     *
     * Raises:
     * HTTPException: If login fails
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public loginUserApiV1AuthLoginPost(
        requestBody: UserLoginRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Login User
     * Login user with email and password.
     *
     * Args:
     * login_data: User login credentials
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * AuthResponse: User data and authentication tokens
     *
     * Raises:
     * HTTPException: If login fails
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public loginUserApiV1AuthLoginPost1(
        requestBody: UserLoginRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Totp Endpoint
     * Generate and send TOTP code for user verification.
     *
     * Args:
     * totp_data: TOTP generation request data
     * db: Database session
     *
     * Returns:
     * TOTPResponse: TOTP generation response
     *
     * Raises:
     * HTTPException: If TOTP generation fails
     * @param requestBody
     * @returns TOTPResponse Successful Response
     * @throws ApiError
     */
    public generateTotpEndpointApiV1AuthGenerateTotpPost(
        requestBody: GenerateTOTPRequest,
    ): CancelablePromise<TOTPResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/generate-totp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Generate Totp Endpoint
     * Generate and send TOTP code for user verification.
     *
     * Args:
     * totp_data: TOTP generation request data
     * db: Database session
     *
     * Returns:
     * TOTPResponse: TOTP generation response
     *
     * Raises:
     * HTTPException: If TOTP generation fails
     * @param requestBody
     * @returns TOTPResponse Successful Response
     * @throws ApiError
     */
    public generateTotpEndpointApiV1AuthGenerateTotpPost1(
        requestBody: GenerateTOTPRequest,
    ): CancelablePromise<TOTPResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/generate-totp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Totp Code
     * Verify TOTP code and complete authentication.
     *
     * Args:
     * totp_data: TOTP verification request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * AuthResponse: User data and authentication tokens
     *
     * Raises:
     * HTTPException: If TOTP verification fails
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public verifyTotpCodeApiV1AuthVerifyTotpPost(
        requestBody: VerifyTOTPRequest,
    ): CancelablePromise<AuthResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/verify-totp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Totp Code
     * Verify TOTP code and complete authentication.
     *
     * Args:
     * totp_data: TOTP verification request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * AuthResponse: User data and authentication tokens
     *
     * Raises:
     * HTTPException: If TOTP verification fails
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public verifyTotpCodeApiV1AuthVerifyTotpPost1(
        requestBody: VerifyTOTPRequest,
    ): CancelablePromise<AuthResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/verify-totp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Logout User
     * Logout user and revoke session.
     *
     * Args:
     * current_user: Current authenticated user
     * credentials: HTTP Bearer token credentials
     *
     * Returns:
     * LogoutResponse: Logout confirmation
     *
     * Raises:
     * HTTPException: If logout fails
     * @returns LogoutResponse Successful Response
     * @throws ApiError
     */
    public logoutUserApiV1AuthLogoutPost(): CancelablePromise<LogoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/logout',
        });
    }
    /**
     * Logout User
     * Logout user and revoke session.
     *
     * Args:
     * current_user: Current authenticated user
     * credentials: HTTP Bearer token credentials
     *
     * Returns:
     * LogoutResponse: Logout confirmation
     *
     * Raises:
     * HTTPException: If logout fails
     * @returns LogoutResponse Successful Response
     * @throws ApiError
     */
    public logoutUserApiV1AuthLogoutPost1(): CancelablePromise<LogoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/logout',
        });
    }
    /**
     * Logout All Sessions
     * Logout user from all sessions.
     *
     * Args:
     * current_user: Current authenticated user
     *
     * Returns:
     * LogoutResponse: Logout confirmation
     *
     * Raises:
     * HTTPException: If logout fails
     * @returns LogoutResponse Successful Response
     * @throws ApiError
     */
    public logoutAllSessionsApiV1AuthLogoutAllPost(): CancelablePromise<LogoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/logout-all',
        });
    }
    /**
     * Logout All Sessions
     * Logout user from all sessions.
     *
     * Args:
     * current_user: Current authenticated user
     *
     * Returns:
     * LogoutResponse: Logout confirmation
     *
     * Raises:
     * HTTPException: If logout fails
     * @returns LogoutResponse Successful Response
     * @throws ApiError
     */
    public logoutAllSessionsApiV1AuthLogoutAllPost1(): CancelablePromise<LogoutResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/logout-all',
        });
    }
    /**
     * Get Current User Info
     * Get current user information.
     *
     * Args:
     * current_user: Current authenticated user
     *
     * Returns:
     * UserResponse: Current user information
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public getCurrentUserInfoApiV1AuthMeGet(): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/me',
        });
    }
    /**
     * Get Current User Info
     * Get current user information.
     *
     * Args:
     * current_user: Current authenticated user
     *
     * Returns:
     * UserResponse: Current user information
     * @returns UserResponse Successful Response
     * @throws ApiError
     */
    public getCurrentUserInfoApiV1AuthMeGet1(): CancelablePromise<UserResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/auth/me',
        });
    }
    /**
     * Refresh Token
     * Refresh access token using refresh token.
     *
     * Args:
     * refresh_data: Refresh token request data
     * db: Database session
     *
     * Returns:
     * TokenResponse: New access and refresh tokens
     *
     * Raises:
     * HTTPException: If token refresh fails
     * @param requestBody
     * @returns TokenResponse Successful Response
     * @throws ApiError
     */
    public refreshTokenApiV1AuthRefreshPost(
        requestBody: RefreshTokenRequest,
    ): CancelablePromise<TokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Token
     * Refresh access token using refresh token.
     *
     * Args:
     * refresh_data: Refresh token request data
     * db: Database session
     *
     * Returns:
     * TokenResponse: New access and refresh tokens
     *
     * Raises:
     * HTTPException: If token refresh fails
     * @param requestBody
     * @returns TokenResponse Successful Response
     * @throws ApiError
     */
    public refreshTokenApiV1AuthRefreshPost1(
        requestBody: RefreshTokenRequest,
    ): CancelablePromise<TokenResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/refresh',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Forgot Password
     * Initiate password reset process.
     *
     * Sends a TOTP verification code to the user's email if the account exists.
     * For security, returns the same response regardless of whether the user exists.
     *
     * Args:
     * request_data: Forgot password request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * ForgotPasswordResponse: Response indicating reset process initiated
     * @param requestBody
     * @returns ForgotPasswordResponse Successful Response
     * @throws ApiError
     */
    public forgotPasswordApiV1AuthForgotPasswordPost(
        requestBody: ForgotPasswordRequest,
    ): CancelablePromise<ForgotPasswordResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Forgot Password
     * Initiate password reset process.
     *
     * Sends a TOTP verification code to the user's email if the account exists.
     * For security, returns the same response regardless of whether the user exists.
     *
     * Args:
     * request_data: Forgot password request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * ForgotPasswordResponse: Response indicating reset process initiated
     * @param requestBody
     * @returns ForgotPasswordResponse Successful Response
     * @throws ApiError
     */
    public forgotPasswordApiV1AuthForgotPasswordPost1(
        requestBody: ForgotPasswordRequest,
    ): CancelablePromise<ForgotPasswordResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/forgot-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Reset Code
     * Verify TOTP code for password reset.
     *
     * Validates the temporary token and TOTP code before allowing password entry.
     * Returns a verified token if successful.
     *
     * Args:
     * request_data: Verify reset code request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * VerifyResetCodeResponse: Response indicating verification success
     *
     * Raises:
     * HTTPException: If verification fails
     * @param requestBody
     * @returns VerifyResetCodeResponse Successful Response
     * @throws ApiError
     */
    public verifyResetCodeApiV1AuthVerifyResetCodePost(
        requestBody: VerifyResetCodeRequest,
    ): CancelablePromise<VerifyResetCodeResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/verify-reset-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Verify Reset Code
     * Verify TOTP code for password reset.
     *
     * Validates the temporary token and TOTP code before allowing password entry.
     * Returns a verified token if successful.
     *
     * Args:
     * request_data: Verify reset code request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * VerifyResetCodeResponse: Response indicating verification success
     *
     * Raises:
     * HTTPException: If verification fails
     * @param requestBody
     * @returns VerifyResetCodeResponse Successful Response
     * @throws ApiError
     */
    public verifyResetCodeApiV1AuthVerifyResetCodePost1(
        requestBody: VerifyResetCodeRequest,
    ): CancelablePromise<VerifyResetCodeResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/verify-reset-code',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reset Password
     * Complete password reset with TOTP verification.
     *
     * Accepts either:
     * - verified_token (from verify-reset-code step, TOTP already verified)
     * - temp_token + totp_code (for direct flow, verifies TOTP here)
     *
     * Args:
     * request_data: Reset password request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * ResetPasswordResponse: Response indicating password reset success
     *
     * Raises:
     * HTTPException: If reset fails
     * @param requestBody
     * @returns ResetPasswordResponse Successful Response
     * @throws ApiError
     */
    public resetPasswordApiV1AuthResetPasswordPost(
        requestBody: ResetPasswordRequest,
    ): CancelablePromise<ResetPasswordResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reset Password
     * Complete password reset with TOTP verification.
     *
     * Accepts either:
     * - verified_token (from verify-reset-code step, TOTP already verified)
     * - temp_token + totp_code (for direct flow, verifies TOTP here)
     *
     * Args:
     * request_data: Reset password request data
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * ResetPasswordResponse: Response indicating password reset success
     *
     * Raises:
     * HTTPException: If reset fails
     * @param requestBody
     * @returns ResetPasswordResponse Successful Response
     * @throws ApiError
     */
    public resetPasswordApiV1AuthResetPasswordPost1(
        requestBody: ResetPasswordRequest,
    ): CancelablePromise<ResetPasswordResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/auth/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
